import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import "./App.css";
import Go from "./components/chooseride/Go";
import Homepage from "./pages/homepage/homepage";
import PackageDelivery from "./components/chooseride/PackageDelivery";
import Food from "./pages/foods/food";
import SEO from "./components/SEO";
import FoodVendors from "./components/chooseride/FoodVendors";
import ChefDetails from "./components/chooseride/ChefDetails";
import RestaurantDetails from "./components/chooseride/RestaurantDetails";
import StoreDetails from "./components/chooseride/StoreDetails";
import { CartProvider } from "./components/chooseride/CartContext";
import { AuthProvider } from "./AuthContext";
import Login from "./pages/Login";
import SignUp from "./pages/SignUp";
import ProtectedRoute from "./components/chooseride/ProtectedRoute";
import Checkout from "./Checkout";
import RideLogin from "./pages/RideLogin";
import RideSignUp from "./pages/RideSignUp";
import Settings from "./pages/Settings";
import RideHistory from "./pages/RideHistory";
import CookieBanner from "./components/CookieBanner/CookieBanner";
import NetworkStatusModal from "./components/NetworkStatusModal/NetworkStatusModal";
import CustomerSupportChat from "./components/CustomerSupportChat/CustomerSupportChat";
import Pricing from "./pages/Pricing";
import About from "./pages/About";
import Careers from "./pages/Careers";
import Help from "./pages/Help";
import Blog from "./pages/Blog";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import Earn from "./pages/Earn";
import ApplyPartner from "./pages/ApplyPartner";
import ScrollToTop from "./components/ScrollToTop";

function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route
          path='/'
          element={
            <>
              <SEO
                title='Home'
                description='Book your next ride, order food, or request deliveries with 9tro Ride. Fast, safe, and reliable services at your fingertips.'
                url='https://www.9troride.com/'
              />
              <Homepage />
            </>
          }
        />
            {/* 9tro Eats / Food Delivery Routes */}
            <Route
              path='/9troeat'
              element={
                <>
                  <SEO
                    title='9tro Eats - Food & Restaurant Delivery'
                    description='Order from your favorite local restaurants and private chefs. 9tro Eats delivers fresh, hot food right to your door in minutes.'
                    url='https://www.9troride.com/9troeat'
                  />
                  <Food />
                </>
              }
            />
            <Route path='/food' element={<Navigate to='/9troeat' replace />} />

            <Route path='/deliveries' element={<Navigate to='/package-delivery' replace />} />
            <Route
              path='/package-delivery'
              element={
                <ProtectedRoute>
                  <SEO
                    title='Package Deliveries'
                    description='Fast and secure package deliveries with 9tro Ride. Track your packages in real-time from pickup to drop-off.'
                    url='https://www.9troride.com/package-delivery'
                  />
                  <PackageDelivery />
                </ProtectedRoute>
              }
            />

            <Route
              path='/9troeat/vendors'
              element={
                <>
                  <SEO
                    title='Select a Chef or Vendor'
                    description='Choose from our wide selection of private chefs and restaurants to deliver your favorite meals.'
                    url='https://www.9troride.com/9troeat/vendors'
                  />
                  <FoodVendors />
                </>
              }
            />
            <Route
              path='/9troeat/chef/:id'
              element={
                <>
                  <SEO
                    title='Chef Details'
                    description='Order delicious meals from our private chefs.'
                  />
                  <ChefDetails />
                </>
              }
            />

            <Route
              path='/9troeat/restaurant/:id'
              element={
                <>
                  <SEO
                    title='Restaurant Details'
                    description='Order delicious meals from our partner restaurants.'
                  />
                  <RestaurantDetails />
                </>
              }
            />

            <Route
              path='/9troeat/store/:id'
              element={
                <>
                  <SEO
                    title='Store Details'
                    description='Order items and groceries from our partner stores.'
                  />
                  <StoreDetails />
                </>
              }
            />
            <Route path='/login' element={<Login />} />
            <Route path='/signup' element={<SignUp />} />
            <Route path='/ride-login' element={<RideLogin />} />
            <Route path='/ride-signup' element={<RideSignUp />} />
            <Route
              path='/go/from/:pickup/to/:dropoff'
              element={
                <ProtectedRoute>
                  <Go />
                </ProtectedRoute>
              }
            />
            <Route
              path='/checkout'
              element={
                <ProtectedRoute>
                  <Checkout />
                </ProtectedRoute>
              }
            />
            <Route
              path='/pricing'
              element={
                <Pricing />
              }
            />
            <Route
              path='/about'
              element={
                <About />
              }
            />
            <Route
              path='/careers'
              element={
                <Careers />
              }
            />
            <Route
              path='/help'
              element={
                <Help />
              }
            />
            <Route
              path='/blog'
              element={
                <Blog />
              }
            />
            <Route
              path='/privacy'
              element={
                <Privacy />
              }
            />
            <Route
              path='/terms'
              element={
                <Terms />
              }
            />
            <Route
              path='/earn'
              element={
                <Earn />
              }
            />
            <Route
              path='/apply'
              element={
                <ApplyPartner />
              }
            />
            <Route
              path='/settings'
              element={
                <ProtectedRoute>
                  <Settings />
                </ProtectedRoute>
              }
            />
            <Route
              path='/ride-history'
              element={
                <ProtectedRoute>
                  <SEO
                    title='Ride History'
                    description='Review your past 9tro Ride trips, rebook routes, check fares, and download trip receipts.'
                    url='https://www.9troride.com/ride-history'
                  />
                  <RideHistory />
                </ProtectedRoute>
              }
            />
            <Route
              path='/rides'
              element={
                <ProtectedRoute>
                  <SEO
                    title='My Rides'
                    description='Track active 9tro Ride trips and review your complete ride history.'
                    url='https://www.9troride.com/rides'
                  />
                  <RideHistory />
                </ProtectedRoute>
              }
            />
          </Routes>
          <CookieBanner />
          <NetworkStatusModal />
          <CustomerSupportChat />
        </BrowserRouter>
      </CartProvider>
    </AuthProvider>
  );
}

export default App;
